<template>
  <div class="p-4">
    <h3 class="mb-3">COMPARTILHAR PERFIL</h3>
    <div class="row">
      <div class="col-6">
        <div class="row">
          <div class="col-12">
            <h4>
              SELECIONE UMA LISTA
            </h4>
          </div>
          <div class="col-12">
            <VueSuggestion
              searchURL="/recruiters/shortlists/"
              :queryParamName="`job_id=${job_id}&search`"
              responseDataName="shortlists"
              :whenSelected="shortlistSelected"
              placeholder="COMECE A DIGITAR PARA BUSCAR"
            />
          </div>
          <div class="col-12 pt-4">
            <h4>
              CRIAR NOVA LISTA
            </h4>
          </div>
          <div class="col-12 pt-1">
            <label>NOME</label>
            <input type="text" v-model="name" class="form-control" />
          </div>
          <div class="col-12 pt-1">
            <button
              :disabled="load_share"
              type="button"
              class="btn mt-3 mb-3 full btn-success"
              @click="createShortlist"
            >
              <span v-show="!load_share">ADICIONAR</span>
              <div
                v-show="load_share"
                class="spinner-border text-light"
                role="status"
              >
                <span class="sr-only"></span>
              </div>
            </button>
          </div>
        </div>
        <div class="col-12 pt-4">
          <h4>
            LISTAS CADASTRADAS
          </h4>
        </div>
        <div class="col-lg-12 col-xs-12" v-if="shortlists.length > 0">
          <table class="table table-hover">
            <thead>
              <tr>
                <td class="center">#</td>
                <td class="center">Nome</td>
                <td>Gestores(as)</td>
              </tr>
            </thead>
            <tbody>
              <tr
                v-for="(shortlist, index) in shortlists"
                :key="shortlist.id"
                class="h-auto"
              >
                <td class="center">
                  <div class="d-inline pointer" @click="removeShortlist(index, shortlist.id)">
                    <i class="fas fa-trash color-red ml-1 scale_1"></i>
                  </div>
                </td>
                <td class="center">
                  <span
                    class="text-truncate d-inline-block"
                    style="max-width: 100px"
                    :title="shortlist.name"
                    >{{ shortlist.name }}</span
                  >
                </td>
                <td>
                  <table>
                    <tr
                      v-for="(manager, manager_index) in shortlist.managers"
                      :key="`manager_${manager_index}_${index}`"
                      class="h-auto"
                    >
                      <td class="center">
                        <div class="d-inline" @click="removeManager(index, manager_index, manager.id)">
                          <i class="fas fa-trash color-red ml-1 scale_1"></i>
                        </div>
                      </td>
                      <td>
                        <span
                          class="text-truncate d-inline-block"
                          style="max-width: 100px"
                          :title="manager.name"
                          >{{ manager.manager_name }}</span
                        >
                      </td>
                      <td
                        class="center"
                      >
                        <span
                          class="pointer color"
                          v-clipboard:copy="manager.url"
                          v-clipboard:success="onCopy"
                        >
                          <font-awesome-icon icon="paperclip" />
                        </span>
                      </td>
                    </tr>
                  </table>
                </td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
      <div class="col-6">
        <div class="row">
          <div class="col-lg-12 col-xs-12">
            <SelectManagers
              inputClasses="form-control"
              :truncate="false"
              :job_id="job_id"
              v-model="managers"
            />
          </div>
          <div class="col-lg-12">
            <label class="mt-3">MENSAGEM</label>
            <textarea class="form-control" rows="6" v-model="message"></textarea>
          </div>
          <div class="col-lg-12 col-xs-12">
            <p class="mt-4">MUDAR O STATUS DOS CANDIDATO(A)S PARA:</p>
            <div class="shadow_bar select_process">
              <label class="pointer">
                <input
                  type="radio"
                  name="status"
                  v-model="select_process_id"
                  value="0"
                />
                NÃO ALTERAR STATUS
              </label>
            </div>
            <div
              class="shadow_bar select_process"
              v-for="process in selective_processes"
              :key="process.id"
              :class="`process${process.status}`"
            >
              <label class="pointer">
                <input
                  type="radio"
                  v-model="select_process_id"
                  name="status"
                  :value="process.id"
                />
                {{ process.name }}
              </label>
            </div>
          </div>
          <div class="col-lg-6 pt-4">
            <label>TEMPO LIMITE DA LISTA</label>
            <select v-model="limit_date" class="form-control">
              <option value="1">1 DIA</option>
              <option value="5">5 DIAS</option>
              <option value="7">7 DIAS</option>
              <option value="10">10 DIAS</option>
              <option value="20">20 DIAS</option>
              <option value="30">30 DIAS</option>
            </select>
          </div>
          <div class="col-lg-6 col-xs-12"></div>
          <div class="col-lg-6 pt-4">
            <button
              :disabled="load_share"
              type="button"
              @click="shareCandidate"
              class="btn mt-3 mb-3 full btn-success"
            >
              <span v-show="!load_share">Compartilhar</span>
              <div
                v-show="load_share"
                class="spinner-border text-light"
                role="status"
              >
                <span class="sr-only"></span>
              </div>
            </button>
          </div>
          <div class="col-lg-12 col-xs-12">
            <a class="f12" :href="url_share" target="_BLANK">{{ url_share }}</a>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { required, email } from "vuelidate/lib/validators";
import ComfirmFeedback from "@/Recruiters/Feedback/Confirm.vue";
import SelectManagers from "components/SelectManagers.vue";
import VueSuggestion from "components/VueSuggestion.vue";

export default {
  props: ["job_id", "apply_ids", "selective_processes"],
  components: { SelectManagers, VueSuggestion },
  data: () => ({
    managers: [],
    url_share: "",
    load_share: false,
    select_process_id: 0,
    limit_date: 7,
    name: "",
    message: "",
    shortlists: [],
    shortlist: null,
  }),
  mounted() {
    this.getShortlists();
  },
  methods: {
    confirmFeedback(feedback, select_process_id, candidates) {
      let candidateCurrent = [];
      for (let i in candidates) {
        candidateCurrent.push({
          candidate_id: candidates[i].id,
          name: candidates[i].name,
          email: candidates[i].email,
          image: candidates[i].image,
        });
      }

      this.$modal.show(
        ComfirmFeedback,
        {
          status: true,
          candidates: candidateCurrent,
          feedback: feedback,
          feedback_selective_process: {
            selective_process_id: select_process_id,
          },
        },
        {
          width: "55%",
          height: "auto",
          scrollable: true,
          // dynamicDefaults: {
          clickToClose: false,
          // }
        }
      );
    },
    shareCandidate() {
      this.load_share = true;
      eventBus.$emit("getManagers");
      if (!this.shortlist?.id) {
        this.load_share = false;
        return this.$toast.error("Selecione uma lista de candidatos");
      }
      if (this.managers.length === 0) return;

      axios
        .post("/recruiters/manager", {
          manager: { managers: this.managers },
          shortlist: {
            id: this.shortlist.id,
            job_id: this.job_id,
            limit_date: this.limit_date,
          },
          message: {
            text: this.message,
          },
        })
        .then((response) => {
          this.url_share = response.data.url;
          axios
            .post(
              `/recruiters/shortlists/${response.data.shortlist.id}/candidates`,
              {
                candidates: {
                  apply_ids: this.apply_ids,
                  select_process_id: this.select_process_id,
                },
              }
            )
            .then((resp) => {
              this.load_share = false;
              this.getShortlists();
              eventBus.$emit("resetSelected");
              if (resp.data.feedback) {
                this.confirmFeedback(
                  resp.data.feedback,
                  this.select_process_id,
                  resp.data.candidates
                );
              } else {
                this.$toast.success("Candidato(a) compartilhado com sucesso");
              }
            });
        });
      this.load_share = false;
    },
    createShortlist() {
      this.load_share = true;
      if (!this.name) {
        this.load_share = false;
        return this.$toast.error("Digite um nome para a lista de candidatos");
      }
      axios.post("/recruiters/shortlists", {
        shortlist: {
          job_id: this.job_id,
          name: this.name,
        },
      })
      .then((response) => {
        this.shortlists.push(response.data.shortlist);
        this.load_share = false;
      });
    },
    removeShortlist(index, id) {
      let conf = confirm(
        "Tem certeza que deseja remover esta lista de candidatos?"
      );
      if (!conf) return;
      axios.delete(`/recruiters/shortlists/${id}`).then((response) => {
        this.shortlists.splice(index, 1);
      });
    },
    shortlistSelected(item) {
      this.shortlist = item;
    },
    removeManager(index, manager_index, id) {
      let conf = confirm("Tem certeza que deseja remover este gestor?");
      if (!conf) return;
      axios
        .delete(`/recruiters/shortlist_managers/${id}`)
        .then((response) => {
          this.shortlists[index].managers.splice(manager_index, 1);
          this.$toast.success("Gestor(a) removido com sucesso");
        });
    },
    getShortlists() {
      axios.get(
        `/recruiters/shortlists?search=*&job_id=${this.job_id}`
      ).then((response) => {
        this.shortlists = response.data.shortlists;
      });
    },
    onCopy() {
      this.$toast.success("LINK COPIADO COM SUCESSO");
    },
  },
};
</script>